import { apiGet, apiPatch } from '@/app/api/core/http';
import { RESEARCHES_PATHS } from './paths';

// Research dictionaries expose a read-only list, only the base url differs
const makeDictionaryResource = (url) => ({
  getList: (params) => apiGet(url + RESEARCHES_PATHS.suffix, { params, is_protected: true }),
});

export const researchesApiAdapter = {
  researchesDomains: makeDictionaryResource(RESEARCHES_PATHS.domains),
  researchesCategories: makeDictionaryResource(RESEARCHES_PATHS.categories),
  researchesAuthors: makeDictionaryResource(RESEARCHES_PATHS.authors),
  researches: {
    getList: (params, cat, headers) => {
      const { clearParams, ...rest } = params;
      let preparedParams = {
        params: rest,
        clearParams,
        is_protected: true,
      };
      if (headers) {
        preparedParams.headers = headers;
      }
      return apiGet(RESEARCHES_PATHS.researches + RESEARCHES_PATHS.suffix, preparedParams);
    },
    getItem: (id) => apiGet(`${RESEARCHES_PATHS.researches}/${id}`),
    update: (id, data) => apiPatch(`${RESEARCHES_PATHS.researches}/${id}`, { data }),
  },
};
